import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
    Feather, Sparkles, BookOpen, Music, Mic, Headphones,
    Book, BookMarked, FileText, MessageCircle, Film, Target
} from "lucide-react";

const PostTypeFilters = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const currentType = searchParams.get("type") || "for_you";

    const categories = [
        { id: "Poetry", label: "Poetry", icon: <Feather size={14} /> },
        { id: "Shayari", label: "Shayari", icon: <Sparkles size={14} /> },
        { id: "Ghazal", label: "Ghazal", icon: <BookOpen size={14} /> },
        { id: "Song", label: "Song", icon: <Music size={14} /> },
        { id: "Rap", label: "Rap", icon: <Mic size={14} /> },
        { id: "Hip-Hop", label: "Hip-Hop", icon: <Headphones size={14} /> },
        { id: "Novel", label: "Novel", icon: <Book size={14} /> },
        { id: "Story", label: "Story", icon: <BookMarked size={14} /> },
        { id: "Book", label: "Book", icon: <FileText size={14} /> },
        { id: "Quote", label: "Quote", icon: <MessageCircle size={14} /> },
        { id: "Script", label: "Script", icon: <Film size={14} /> },
    ];

    const handleCategoryClick = (id) => {
        if (currentType === id) {
            // Toggle off if already active
            navigate("/feed?type=for_you");
        } else {
            navigate(`/feed?type=${id}`);
        }
    };

    return (
        <div className="w-full lg:hidden top-[60px] z-20 pb-3">
            <div className="flex overflow-x-auto gap-4 pr-6 py-2 no-scrollbar scroll-smooth">
                {categories.map((cat) => {
                    const isActive = currentType === cat.id;

                    return (
                        <button
                            key={cat.id}
                            onClick={() => handleCategoryClick(cat.id)}
                            className="flex-shrink-0 flex flex-col items-center gap-1.5 transition-all duration-300 group"
                        >
                            {/* Icon with circular border */}
                            <div
                                className={`w-16 h-16 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${isActive
                                    ? "bg-[#b0d284] border-[#b0d284]"
                                    : "bg-white border-[#b0d284]"
                                    }`}
                            >
                                <span className="text-black">
                                    {React.cloneElement(cat.icon, { size: 24 })}
                                </span>
                            </div>

                            {/* Filter name below icon */}
                            <span
                                className={`text-[14px] tracking-tight transition-colors duration-300 text-black
                                    }`}
                            >
                                {cat.label}
                            </span>
                        </button>
                    );
                })}
            </div>
            <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
        </div>
    );
};

export default PostTypeFilters;
